import { CircularProgress, CircularProgressProps } from "@mui/material";

export const LoadingSpinner = (props: CircularProgressProps) => <CircularProgress {...props} />;
